import { Switch } from 'react-router';
import { LayerRoute } from '../../taboola-common-frontend-modules/multi-layer-drawer/components/LayerRoute/LayerRoute';
import { PUSH_API_CREATOR_ROUTE_PATH } from '../config';
import { PushApiCreatorPage } from './PushApiCreatorPage';

const path = PUSH_API_CREATOR_ROUTE_PATH;

export const PushApiCreator = ({ onCancel }) => {
    return (
        <Switch>
            <LayerRoute strict path={path} render={() => <PushApiCreatorPage onCancel={onCancel} />} />
        </Switch>
    );
};
